import { render, staticRenderFns } from "./UrunPaketleme.vue?vue&type=template&id=cd72a0f6"
import script from "./UrunPaketleme.vue?vue&type=script&lang=js"
export * from "./UrunPaketleme.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports